import React, { useEffect, useState } from "react";
import cx from "classnames";
import { ValidationMessage } from "../validationMessage";
import ToolTipIcon from "../toolTipIcon";
import Wrapper, { LabelTypography } from "./select.styles";
import { createOption } from "../../constants/options";
import { isNotNullOrEmpty } from "@src/utils/helpers/stringHelper";

const createValueOption = (value, previewMapper) => {
  const safePreviewMapper = previewMapper || ((v) => v);
  
  return createOption(safePreviewMapper(value), value);
};

const createLoadingOptions = (value, previewMapper) => {
  return value ? [createValueOption(value, previewMapper)] : null;
};

const useTransparentDisable = (loading) => {
  const [showDisabled, setShowDisabled] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowDisabled(false);
    }
  }, [loading, setShowDisabled])

  const onOuterClick = () => {
    if (loading) {
      setShowDisabled(true);
    }
  };

  const style = {pointerEvents: loading ? "none" : "auto"};
  
  return [showDisabled, onOuterClick, style];
};;

export const Select = ({ ...props }) => {
  const {
    options,
    valueKey,
    labelKey,
    loading,
    title,
    toolTipText,
    OptionalLabel,
    errorMessage,
    isPlaceHolder,
    placeholder,
    padded,
    value,
    previewMapper,
    ...rest
  } = props;
  
  const fallback = loading ? createLoadingOptions(value, previewMapper) : undefined;
  const [showDisabled, onOuterClick, style] = useTransparentDisable(loading);

  return (
    <Wrapper onClick={onOuterClick}>
      <div className={cx("select-Component", {padded})} data-testid="select-component" style={style} >
        {title && (
          <LabelTypography className={cx("select-Label",  { error: isNotNullOrEmpty(errorMessage) })}>
            {title}
            {!!toolTipText && <ToolTipIcon toolTipText={toolTipText} />}
            {OptionalLabel && (
              <label className="textBox-Label-Optional">optional</label>
            )}
          </LabelTypography>
        )}
        {showDisabled && (
          <div className="select-loader">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="spinner"
              className="svg-inline--fa fa-spinner fa-w-16 select-spinner-icon"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
              ></path>
            </svg>
          </div>
        )}
        <select
          className={`select-Select ${errorMessage ? "required" : ""} `}
          value={value || ""}
          aria-label={title}
          {...rest}
        >
          {isPlaceHolder && <option value="">{placeholder}</option>}
          {(fallback || options || []).map((item, index) => (
            <option
              key={`${new Date().getTime()}${index}`}
              className={`select-Option${index}`}
              value={item[valueKey] || item.value}
            >
              {item[labelKey] || item.label}
            </option>
          ))}
        </select>
        <ValidationMessage errorMessage={errorMessage} />
      </div>
    </Wrapper>
  );
}

export default Select;